import { Fragment } from "react";
import { Col, Form } from "react-bootstrap";
import CompanyEnum from "../../../enums/company/CompanyEnum";

function FilterShipments({ value, set }) {
  return (
    <Fragment>
      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label>تعداد نمایش:</Form.Label>
        <Form.Select
          defaultValue={value.get("items")}
          onChange={e => set({ label: "items", value: e.target.value })}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </Form.Select>
      </Col>

      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label>سرویس دهنده:</Form.Label>
        <Form.Select
          defaultValue={value.get("company")}
          onChange={e => set({ label: "company", value: e.target.value })}
        >
          <option value={0}>همه</option>
          {Object.keys(CompanyEnum).map(item => (
            <option key={item} value={item}>
              {CompanyEnum[item]}
            </option>
          ))}
        </Form.Select>
      </Col>

      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label>وضعیت:</Form.Label>
        <Form.Select
          defaultValue={value.get("status")}
          onChange={e => set({ label: "status", value: e.target.value })}
        >
          <option value="">همه</option>
          <option value="تایید نهایی">تایید نهایی</option>
          <option value="جمع آوری نشده">جمع آوری نشده</option>
          <option value="ارجاع به راننده">ارجاع به راننده</option>
          <option value="معلق">معلق در فروشگاه</option>
          <option value="تحویل داده شده">تحویل سرویس دهنده</option>
          <option value="برگشتی">برگشتی</option>
          <option value="تحویل مشتری">تحویل مشتری</option>
          <option value="لغو موقت">لغو موقت</option>
          <option value="لغو شده">لغو شده</option>
        </Form.Select>
      </Col>

      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label>نوع پرداخت:</Form.Label>
        <Form.Select
          defaultValue={value.get("methodPayment")}
          onChange={e => set({ label: "methodPayment", value: e.target.value })}
        >
          <option value={0}>همه</option>
          <option value={1}>پیشکرایه (آنلاین)</option>
          <option value={2}>پسکرایه</option>
          <option value={3}>پرداخت در محل-COD</option>
        </Form.Select>
      </Col>

      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label>شماره سفارش:</Form.Label>
        <Form.Control
          type="number"
          defaultValue={value.get("barname")}
          onChange={e => set({ label: "barname", value: e.target.value })}
        />
      </Col>
    </Fragment>
  );
}

export default FilterShipments;
